import { render, staticRenderFns } from "./FornecedoresLista.vue?vue&type=template&id=42b14cb1&scoped=true&"
import script from "./FornecedoresLista.vue?vue&type=script&lang=js&"
export * from "./FornecedoresLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b14cb1",
  null
  
)

export default component.exports